// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/account_role.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/account_role.proto.
 */
export const file_studyo_today_schools_v1_resources_account_role = /*@__PURE__*/
  fileDesc("CjRzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvYWNjb3VudF9yb2xlLnByb3RvEiFzdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMqXAoLQWNjb3VudFJvbGUSHAoYQUNDT1VOVF9ST0xFX1VOU1BFQ0lGSUVEEAASFwoTQUNDT1VOVF9ST0xFX01FTUJFUhABEhYKEkFDQ09VTlRfUk9MRV9BRE1JThACQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.schools.v1.resources.AccountRole.
 */
export const AccountRoleSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schools_v1_resources_account_role, 0);

/**
 * All possible account roles which can be set on an account.
 *
 * @generated from enum studyo.today.schools.v1.resources.AccountRole
 */
export const AccountRole = /*@__PURE__*/
  tsEnum(AccountRoleSchema);

